import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ProcessSection from './components/ProcessSection';
import SalesMethodSection from './components/SalesMethodSection';
import DocumentsSection from './components/DocumentsSection';
import PricingSection from './components/PricingSection';
import SafetySection from './components/SafetySection';
import CTASection from './components/CTASection';
import { SEO } from '../../utils/seo';

export default function SellPage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: '会社売却サービス',
    description: '休眠会社や稼働法人の売却をサポート。スピード対応と専門家サポートで安心の取引を実現します。',
    provider: {
      '@type': 'Organization',
      name: '株式会社G11'
    },
    areaServed: 'JP',
    serviceType: '会社売却仲介'
  };

  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="会社を売りたい方へ | 会社売却・法人譲渡サービス | 株式会社G11"
        description="休眠会社や稼働法人の売却をサポート。スピード対応と専門家サポートで安心の取引を実現します。売却の流れ、必要書類、料金体系など詳しくご説明します。"
        keywords="会社売却,法人譲渡,休眠会社売却,事業譲渡,M&A仲介,会社売買"
        jsonLd={jsonLd}
      />
      <Navbar />
      <HeroSection />
      <ProcessSection />
      <SalesMethodSection />
      <DocumentsSection />
      <PricingSection />
      <SafetySection />
      <CTASection />
      <Footer />
    </div>
  );
}
